var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('button',{on:{"click":_vm.getAlbum}},[_vm._v("Get Album")])])}
var staticRenderFns = []

export { render, staticRenderFns }